import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'combo-tipo-escola',
  templateUrl: './combo-tipo-escola.component.html',
  styleUrls: ['./combo-tipo-escola.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ComboTipoEscolaComponent implements OnInit {

  @ViewChild('comboTipoEscola', {static: false}) comboTipoEscola;

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;

  @Output() valorChange = new EventEmitter();

  dados = [
    { id: 1, tipo: 'Pública', flag: 'P' },
    { id: 2, tipo: 'Privada', flag: 'R' }
  ];
  data: any = {};

  constructor() {
  }

  ngOnInit(): void {
    this.data = Date.now();
    this.preencherCombo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.preencherCombo();
  }

  private preencherCombo(){
    if (this.selecionado && this.dados.length) {
      if (typeof this.selecionado === 'string') {
        this.selecionado = _.find(this.dados, { flag: this.selecionado});
      }
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }

}
